import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Image from '../../components/Image/Image';
import _ from 'lodash';
import useSWR from 'swr';
import { apiClient } from '../../../helpers/apiHelperV2';
import { useStandortHistory } from '../../components/VHost/StandortHistory';
import { subLocationsToMarkers } from '../../components/Map/markerHelper';
import MapSelector from '../../components/Map/MapSelector';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import Button from '../../components/form-elements/Button';
import classnames from 'classnames';
import LocationCardsWrapper from '../../components/LocationLists/LocationCardsWrapper';
import LocationCard from '../../components/LocationLists/LocationCard';
import MoreRegionsTrailingCard from '../../components/LocationLists/MoreRegionsTrailingCard';
import { navigateToSubLocation } from '../../../modules/actions/standort/subLocation';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import FeaturedCategoryCards from '../../components/ServiceCategories/ServiceCategories';
import { dienstleistungenResponseSelector } from '../../../modules/selectors/standort/dienstleistungen';
import SubCategoryLinks from '../../components/Categories/SubCategoryLinks';

function Ueberuns() {
    const markenStandort = useSelector(markenStandortSelector);
    const history = useStandortHistory();
    const [selectedCarMake, setSelectedCarMake] = useState('');
    const [showLocationList, setShowLocationList] = useState(false);
    const ServiceCategoriesRef = useRef(null);
    const [isOpen, setIsOpen] = useState(true);
    const chevronBtnRef = useRef(null);
    const dienstleistungenResponse = useSelector(dienstleistungenResponseSelector);

    useEffect(() => {
        if (chevronBtnRef.current) {
            const observer = new MutationObserver(() => {
                const svg = chevronBtnRef.current.querySelector('svg');
                if (svg) {
                    svg.setAttribute('focusable', 'false');
                    svg.setAttribute('aria-hidden', 'true');
                    observer.disconnect();
                }
            });
            observer.observe(chevronBtnRef.current, { childList: true, subtree: true });
            const svg = chevronBtnRef.current.querySelector('svg');
            if (svg) {
                svg.setAttribute('focusable', 'false');
                svg.setAttribute('aria-hidden', 'true');
                observer.disconnect();
            }
        }
    }, [isOpen]);

    const toggleServiceView = () => {
        setIsOpen(!isOpen);
    }

    const { data: areaShopsResponse } = useSWR(`/api/v1/AreaShops?standortUrl=${markenStandort.url}`, async url => {
        const { data } = await apiClient.get(url);
        return data;
    });

    const { data: seitenTexteResponse } = useSWR(`/api/v1/SeitenTexte?standortUrl=${markenStandort.url}`, async url => {
        const { data } = await apiClient.get(url);
        return data;
    });

    const areaShops = useMemo(() => areaShopsResponse?.areaShops ?? [], [areaShopsResponse]);
    const carMakes = useMemo(() => _.uniq(areaShops.flatMap(areaShop => areaShop.allCars)), [areaShops]);

    const seitenTexte = useMemo(() => seitenTexteResponse?.body ?? [], [seitenTexteResponse]);

    const about = (seitenTexte && seitenTexte.find(text => text.name === 'About-Text')) || undefined;

    const markers = useMemo(() => {
        if (areaShops.length > 0) {
            return areaShops.flatMap(areaShop => {
                return subLocationsToMarkers({
                    subLocations: areaShop.areaShopSubLocations,
                    standortUrl: areaShop.url,
                    history,
                });
            });
        }
        return [];
    }, [areaShops, history]);

    const locations = useMemo(() => {
        if (selectedCarMake) {
            return areaShops[0].areaShopSubLocations.filter(location => {
                const locationCarMakes = [location.hauptFabrikat, ...location.nebenFabrikat];
                return locationCarMakes.includes(selectedCarMake) && !location.terminated;
            });
        } else {
            return areaShops && areaShops.length > 0 ? areaShops[0]?.areaShopSubLocations.filter(location => !location.terminated) : [];
        }
    }, [areaShops, selectedCarMake]);


    const onCareMakeFilterChanged = useCallback(carMake => setSelectedCarMake(carMake), []);


    const removeCitroenVariation = (list) => {
        if (list.includes("Citroen") && list.includes("Citroën")) {
            list = list.filter(item => item !== "Citroën");
        }
        return list;
    }

    const filteredCarMakes = removeCitroenVariation(carMakes);

    const { data: serviceNavigatorstatus } = useSWR(`/api/v1/getServicenavigatorStatus?standortId=${markenStandort._id}`, async url => {
        const { data } = await apiClient.get(url);
        return data;
    });

    const serviceNavigatorStatus = useMemo(() => serviceNavigatorstatus?.status ?? [], [serviceNavigatorstatus]);
    
    return (
        <>
            <BreadCrumbSelector />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container">
                    <h3>{markenStandort.anschrift.firma}</h3>
                    {about && <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: about.text }} />}
                    <Image
                        className="uk-width-1-1"
                        src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Matrix1.jpg`}
                        alt={markenStandort.aboutUsImageAltText ?? 'Standortbild'}
                    />
                </div>
            </section>
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container">
                    <h3>Bitte wählen Sie eine Marke aus!</h3>
                    <div className="uk-tile uk-padding-small" style={{ backgroundColor: "black" }}>
                        <div className="uk-grid uk-grid-small uk-flex uk-flex-center uk-grid-match" data-uk-grid="">
                            {filteredCarMakes.map(carMake => (
                                <div key={carMake}>
                                    <Button
                                        modifier="link"
                                        className="focus-brand"
                                        onClick={() => {
                                            onCareMakeFilterChanged(carMake);
                                        }}
                                    >
                                        <div
                                            className={classnames(
                                                'uk-tile uk-padding-small uk-height-1-1 uk-flex uk-flex-middle',
                                                selectedCarMake === carMake ? 'uk-tile-primary' : 'uk-tile-default'
                                            )}
                                        >
                                            <Image
                                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/images/brand-icons/${carMake}.jpeg`}
                                                alt={carMake}
                                                resizeHeight={40}
                                            />
                                        </div>
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="uk-position-relative">
                        <MapSelector markers={markers} height="60vh" />
                        <div className="uk-position-bottom-right uk-position-medium">
                            <Button modifier="primary" onClick={() => setShowLocationList(!showLocationList)} ariaControls="subLocationFinderLocations" ariaExpanded={showLocationList}>
                                {showLocationList ? 'Adressen ausblenden' : 'Adressen einblenden'}
                            </Button>
                        </div>
                    </div>
                    <div id='subLocationFinderLocations' className='uk-magin-remove'>
                        {showLocationList && (
                            <LocationCardsWrapper>
                                {locations.map((location, index) => (
                                    <div key={location._id}>
                                        <LocationCard
                                            forProductDetail={false}
                                            location={location}
                                            positionNumber={index + 1}
                                            footerChildren={
                                                <Button
                                                    modifier="secondary"
                                                    fullWidth
                                                    ariaLabel={`mehr Infos zum Standort ${location?.anschrift?.ort}`}
                                                    onClick={() => {
                                                        navigateToSubLocation({ history, subLocationUrl: location.subLocationUrl });
                                                    }}
                                                >
                                                    MEHR INFOS
                                                </Button>
                                            }
                                        />
                                    </div>
                                ))}
                                {markenStandort.gesellschafterAreaShopCount > 1 && (
                                    <div>
                                        <MoreRegionsTrailingCard />
                                    </div>
                                )}
                            </LocationCardsWrapper>
                        )}
                    </div>
                </div>
            </section>
            {!serviceNavigatorStatus && !markenStandort.noServiceRequest && (
                <section ref={ServiceCategoriesRef} className="uk-section uk-section-muted">
                    <div className="uk-container">
                        <div className={isOpen ? "open" : "closed"}>
                            <ReduxSuspense response={dienstleistungenResponse}>
                                {dienstleistungen => <FeaturedCategoryCards dienstleistungen={dienstleistungen} gfsshop={true}/>}
                            </ReduxSuspense>
                        </div>
                    </div>
                </section>
            )}
            <SubCategoryLinks />
        </>
    );
}

export default Ueberuns;
